<script>
import codeTable from '@/components/table';
import edit from './codeEdit';
import topBar from './topbar';
import columnsConfig from '@/modules/config/columns';
import {mapActions, mapMutations, mapGetters} from 'vuex';
export default {
	created() {
        this.initProvince();
		this.handleGetUserList();
        this.promiseAll();
	},
	data() {
		return {
			authOption: {
				data: [],
				pageQuery: {
					total: 0,
					pageSize: 20,
					currentPage: 1,
					pageSizeList: [20, 40, 60]
				},
				searchQuery: {
					mobile: '',
					provinceId: '',
					cityId: '',
					countryId: '',
                    queryTimeBegin: '',
                    queryTimeEnd: ''
				},
			},
			selectOption: {
				provinceId: [],
				cityId: [],
				vip: [],
				status: [{value: 0, label: '停用'}, {value: 1, label: '启用'}]
			},
			codeDetail: {},
			dialogOption: {
				width: '40%',
				title: '项目编辑',
				type: 1, // 0新增， 1编辑
				show: false
			}
		}
	},
	methods: {
        initProvince() {
            this.selectOption.provinceId = this.cityList.filter(item => item.parentId === 0);
        },
        // 获取选择项
        promiseAll() {
            Promise.all([this.vipType()]).then(res => {
                this.selectOption.vip = res[0].data || [];
            });
        },
		// 获取选择项
		// async handleDelete(row){
        //     this.$confirm('此操作将永久删除, 是否继续?', '提示', {
        //         confirmButtonText: '确定',
        //         cancelButtonText: '取消',
        //         type: 'warning'
        //     }).then(() => {
        //         this.delete(row);
        //     })
		// },
        // async delete(row) {
        //     const id = row.id;
		// 	const {code} = await this.textDel({id});
		// 	if (Object.is(code, 200)) {
		// 		this.$message.success('删除成功');
		// 		this.handleGetUserList();
		// 	}
        // },
		handleEdit(row, type, title) {
			this.codeDetail = row;
			this.dialogOption.type = type;
			this.dialogOption.title = title;
			this.dialogOption.show = true;
			this.$nextTick(()=> {
				this.$refs.edit.modelStatus(true);
			});
		},
		async handleGetUserList() {
			this.$loading(true);
			const {pageQuery, searchQuery} = this.authOption;
			const {pageSize, currentPage}  = pageQuery;
			try {
				const {code, data} = await this.getUserList({
					...searchQuery, pageSize, currentPage
				});
				this.authOption.data = data && data.dataSource || [];
				this.authOption.pageQuery.total = data && data.total;
			} catch (e) {
				throw e;
			} finally {
			    this.$loading(false);
			}
		},
		skipPage({id}) {
			this.$router.push({
				path: `/policy/country/detail/${id}`,
				query: {
					event: 'getTextDetail'
				}
			})
		},
		change({value, type}) {
			this.authOption.pageQuery.currentPage = 1;
			if (Object.is(type, 'provinceId')) {
				this.authOption.searchQuery.cityId = '';
				this.selectOption.cityId = this.setCity(value);
			}
		},
		setCity(val) {
			return this.cityList.filter(item => item.parentId === val);
		},
		...mapActions('zft',['getUserList', 'updateUser', 'getCityList', 'vipType'])
	},
	computed: {
		...mapGetters('zft', ['cityList']),

		columns() {
			return columnsConfig;
		}
	},
	components: {
		codeTable, topBar, edit
	},
	watch: {
		'cityList': function() {
			this.selectOption.provinceId = this.cityList.filter(item => item.parentId === 0);
		}
	}
}
</script>
<template>
<div class="rule-list">
	<top-bar
	  :handlerCodeSearch="handleGetUserList"
	  :searchQuery="authOption.searchQuery"
	  :selectOption="selectOption"
	  @change="change"
	></top-bar>
    <code-table
     :data="authOption.data"
     :columns="columns.userColumns"
     :searchEvent="handleGetUserList"
     :pageOptions="authOption.pageQuery"
    >

		<el-table-column label="状态" align="center" slot="status">
            <template slot-scope="scope">
				<i class="el-icon-circle-check" style="font-size: 20px;color:#8ab044" v-if="scope.row.status === 1"></i>
				<i class="el-icon-circle-close"  style="font-size: 20px;color:red" v-else></i>
	        </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="80" slot="operate">
            <template slot-scope="scope">
	            <el-button type="success"  @click="handleEdit(scope.row, 1, '用户编辑')">编辑</el-button>
	        </template>
        </el-table-column>
    </code-table>
    <edit ref="edit"
	  :dialogOption="dialogOption"
	  :codeEvent="updateUser"
	  :searchEvent="handleGetUserList"
	  :codeDetail="codeDetail"
	  :selectOption="selectOption"
	></edit>
</div>
</template>
<style scoped lang="stylus">
.rule-list
    padding 20px 20px 0
	.active
	    color #286AB1
</style>
